import React, { useState, useEffect } from 'react';
import './styles/nyheder.css';
import SecondaryButton from './secondaryButton';
import MainButton from './mainButton';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

const Nyheder = () => {
  const [nyheder, setNyheder] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchNyheder = async () => {
      try {
        const nyhedDocRef = doc(db, 'content', 'nyheder');
        const nyhedDoc = await getDoc(nyhedDocRef);
        
        if (nyhedDoc.exists() && nyhedDoc.data().items) {
          // Sorter nyheder efter ID (nyeste først)
          // Vi antager at ID'er er i formatet 'nyhed_TIMESTAMP'
          const sortedNyheder = [...nyhedDoc.data().items].sort((a, b) => {
            // Forsøg at sortere efter id (hvis det indeholder timestamp)
            const aId = a.id.includes('_') ? parseInt(a.id.split('_')[1]) : 0;
            const bId = b.id.includes('_') ? parseInt(b.id.split('_')[1]) : 0;
            
            // Sortér faldende (nyeste først)
            return bId - aId;
          });
          
          // Begræns til de 4 nyeste nyheder
          setNyheder(sortedNyheder.slice(0, 4));
        } else {
          // Fallback til standardnyheder
          setNyheder([
            {
              id: 'nyhed_1',
              title: 'Supervision på vej til autorisation',
              content: 'Sidsel udbyder en supervisionsgruppe. 30 timers supervision. Se mere under SUPERVISION - AUTORISATION',
              buttonText: 'Læs mere',
              buttonLink: '/supervision',
              imageUrl: '/media/nyheder/supervision.avif'
            },
            {
              id: 'nyhed_2',
              title: 'Følelseskort',
              content: 'Til brug i terapi og samtaler med børn, unge og familier.\n\nVi har udviklet og produceret et sæt kort med forskellige følelser som kan bestilles i shoppen her på hjemmesiden',
              buttonText: 'Køb nu',
              buttonLink: '/shop',
              imageUrl: '/media/nyheder/følelseskort.avif'
            },
            {
              id: 'nyhed_3',
              title: 'Ny MBT uddannelse maj 2024',
              content: 'Vi har sammensat en ny spændende terapeutisk specialistgodkendt uddannelse for psykologer og psykiatere med et meget kompetent hold af undervisere fra hele europa. Læs mere om uddannelsen under UDDANNELSER - MBT',
              buttonText: 'Læs mere',
              buttonLink: '/uddannelse',
              imageUrl: '/media/hero/MBT-klodser.avif'
            }
          ]);
        }
      } catch (error) {
        console.error('Fejl ved hentning af nyheder:', error);
        // Fallback til tomme nyheder
        setNyheder([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchNyheder();
  }, []);

  if (isLoading) {
    return null; // Eller en loading indikator
  }

  // Hvis der ikke er nogen nyheder, viser vi ikke sektionen
  if (nyheder.length === 0) {
    return null;
  }

  return (
    <section className="nyheder">
      <h2>Nyheder</h2>
      <div className="nyheder-grid">
        {nyheder.map((nyhed, index) => (
          <article className="nyhed" key={nyhed.id}>
            <div className="nyhed-indhold">
              <h3>{nyhed.title}</h3>
              {nyhed.content.split('\n\n').map((paragraph, idx) => (
                <p key={idx}>{paragraph}</p>
              ))}
              <SecondaryButton href={nyhed.buttonLink}>{nyhed.buttonText}</SecondaryButton>
            </div>
            <div className="nyhed-billede">
              <img src={nyhed.imageUrl} alt={nyhed.title} />
            </div>
          </article>
        ))}
      </div>
      <div className="se-alle-nyheder">
        <MainButton href="/nyheder">Læs mere</MainButton>
      </div>
    </section>
  );
};

export default Nyheder;
